import { getTopRatedComics, getHotComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';
import { useState } from 'react';

export default function RankingSection() {
  const [activeTab, setActiveTab] = useState<'hot' | 'rating'>('hot');
  const hotComics = getHotComics(10);
  const topRated = getTopRatedComics(10);
  const displayComics = activeTab === 'hot' ? hotComics : topRated;

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-8 gap-4">
          <div>
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 rounded-full text-xs font-medium mb-3">
              排行榜
            </span>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              热门排行
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              根据阅读量和评分综合排名
            </p>
          </div>

          <div className="flex items-center bg-secondary-100 rounded-full p-1">
            <button
              onClick={() => setActiveTab('hot')}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeTab === 'hot'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-800'
              }`}
            >
              人气榜
            </button>
            <button
              onClick={() => setActiveTab('rating')}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeTab === 'rating'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-800'
              }`}
            >
              评分榜
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-background-50 rounded-lg p-5">
            <div className="flex flex-col gap-0">
              {displayComics.slice(0, 5).map((comic, index) => (
                <div key={comic.id}>
                  <ComicCard comic={comic} variant="hot" />
                </div>
              ))}
            </div>
          </div>
          <div className="bg-background-50 rounded-lg p-5">
            <div className="flex flex-col gap-0">
              {displayComics.slice(5, 10).map((comic, index) => (
                <div key={comic.id}>
                  <ComicCard comic={comic} variant="hot" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}